module.exports = __webpack_public_path__ + "static/img/11022C_2_3_4_5_C_20210719_LC.8ab87e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11022C_2_3_4_5_C_20210719_LC.png
// module id = Q9Oq
// module chunks = 0